var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ConsentForm',{on:{"after-submit":_vm.afterSubmit}})
}
var staticRenderFns = []

export { render, staticRenderFns }